import React from "react";
import "./RetryComponent.css"; // Import the CSS file

const RetryComponent = ({ onRetry = () => {} }) => {
  return (
    <div className="retry-container">
      <h2 className="retry-title">Something went wrong</h2>
      <p className="retry-message">Please try again.</p>
      <button className="retry-button" onClick={onRetry}>
        Retry
      </button>
    </div>
  );
};

export default RetryComponent;
